import { useDispatch } from 'react-redux';
import { AppDispatch } from '../ts/types/store';

export const useAppDispatch: () => AppDispatch = useDispatch;
